/**
 *
 * @link https://date-fns.org/v2.28.0/docs/parse
 * @link https://date-fns.org/v2.28.0/docs/parseJSON
 *
 */
import { parse as dateFnsParse } from 'date-fns';
import parseJSON from 'date-fns/parseJSON';

/**
 * Devuelve la fecha convertida a tipo `Date`.
 *
 * @param {string|number|Date} value la fecha a parsear
 * @param {string} [format] el formato si la fecha es de tipo string, indica como leer la fecha `value`
 * @returns {Date}
 *
 * @throws {TypeError} Invalid date (desde Date-fns) si no consigue interpretar la fecha
 * @throws {TypeError} Tipo de `value` incorrecto
 */
export function parse(value, format) {
  if (!value || value instanceof Date) {
    return value;
  }

  if (typeof value === 'string') {
    if (format && typeof format === 'string') {
      return dateFnsParse(value, format, new Date());
    }
    return parseJSON(value);
  }

  if (typeof value === 'number') {
    return new Date(value);
  }

  throw new TypeError(`value must be a string, a number or a Date`);
}
